import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls, formatter } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { topUpAPI } from 'api/icash'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  IcashTopupTxFormTypes,
  IcashTopupTxFormSubmitValuesTypes,
  IcashTopupTxFormSubmitActionsTypes,
} from 'types/icashTopupTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const PURCHASETXINITVAL: IcashTopupTxFormTypes = {
  creditValue: 0,
  externalTransactionId: 0,
  ident: '',
  cashier: '',
  guid: '',
  storeId: 0,
  deviceCode: '',
  transactionDate: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
}

export const useIcashTopupTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: IcashTopupTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleMerchantSet: (merchant: MerchantLookupTypes[]) => void
  handleSubmitIcashTopupTx: (
    values: IcashTopupTxFormSubmitValuesTypes,
    actions: IcashTopupTxFormSubmitActionsTypes
  ) => void
  handleClearIcashTopupTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] = useState<IcashTopupTxFormTypes>({
    ...PURCHASETXINITVAL,
    cashier: authTokenUsername,
    externalTransactionId: formatter.externalIdentification(),
    ident: String(member?.cardNumber) || '',
  })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleMerchantSet = useCallback(
    async (merchant: MerchantLookupTypes[]) => {
      try {
        purchaseTxMerchantSet(merchant)
        toast.success('Merchant Selected')
      } catch (error) {
        toast.error('Something went wrong.')
      }
    },
    [purchaseTxMerchantSet]
  )

  const handleSubmitIcashTopupTx = useCallback(
    async (
      values: IcashTopupTxFormSubmitValuesTypes,
      actions: IcashTopupTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        if (String(values.externalTransactionId) === "") {
          values.externalTransactionId = initialValues.externalTransactionId + 1
        }
        await topUpAPI(values)
        toast.success('iCash topup successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearIcashTopupTx = useCallback(() => {
    initialValuesSet({ ...PURCHASETXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleMerchantSet,
    handleSubmitIcashTopupTx,
    handleClearIcashTopupTx,
  }
}
